import styles from "../../../styles/Components/mini-app/mini-portfolio/CurrentAccountInfo.module.css";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";
import useExchangePortfolioInfo from "../../../hooks/exchange/useExchangePortfolioInfo";
import { Skeleton } from "antd";
import { formatPrice } from "../../../utility/helper";
import MiniExchangesButton from "../MiniExchangesButton";

function CurrentAccountInfo() {
  const {
    exchangeState: { selectedPortfolioExchange, exchanges },
  } = useSelector((state) => state);

  const exchangeInfo = exchanges?.find(
    (exchange) => exchange?.id === selectedPortfolioExchange,
  );

  const { balanceLoading, portfolioLoading, balanceChange, totalBalance } =
    useExchangePortfolioInfo();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h5>Accounts</h5>
        {/*<span className={styles.exchangeBtn}>Exchanges</span>*/}
        <MiniExchangesButton className={styles.exchangeBtn} />
      </div>

      <div className={styles.body}>
        <div className={styles.exchangeInfo}>
          <div className={styles.exchangeIcon}>
            <LazyLoadImage
              src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${selectedPortfolioExchange}.svg`}
              alt="DemoExchange Logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/placeholders/exchange-logo.svg";
              }}
              width="20px"
              height="20px"
              effect="blur"
              style={{ borderRadius: "100%" }}
            />
          </div>
          <div className={styles.exchangeName}>
            <h5>
              {selectedPortfolioExchange === "cryptocrispy"
                ? "Demo Account"
                : exchangeInfo?.name}
            </h5>
            <p>
              Spot Account{" "}
              {selectedPortfolioExchange === "cryptocrispy"
                ? "Simulator"
                : null}
            </p>
          </div>
        </div>
        <div className={styles.balanceInfo}>
          <span>
            {portfolioLoading ? (
              <Skeleton.Node active />
            ) : (
              `$${formatPrice(totalBalance)}`
            )}
          </span>
        </div>
      </div>
    </div>
  );
}

export default CurrentAccountInfo;
